import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Locale } from '@shared/models/locale';

@Injectable({
  providedIn: 'root'
})
export class EnLanguagesGuard  {
  constructor(private translate: TranslateService, private router: Router) {}
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  canActivate(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    route: ActivatedRouteSnapshot,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.translate.currentLang === Locale.EN_US) {
      this.router.navigate([`./opendata`]);
      return false;
    }
    return true;
  }
}
